module.exports = __webpack_public_path__ + "img/2.977b8ce5.png";